import styled from 'styled-components'
import { Typography } from 'antd'
import { Payload } from 'recharts/types/component/DefaultLegendContent'
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

const { Text: AntText } = Typography

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.foundation.borderRadius};
  border: 2px solid ${({ theme }) => theme.colors.grey2};
  display: flex;
  flex-direction: column;
  padding: 10px;
`

const SubTitle = styled(AntText)`
  font-weight: normal !important;
  margin-bottom: 0px !important;
  line-height: 24px;
  font-size: 14px !important;
  color: ${({ theme }) => theme.colors.olive};
`

interface TooltipProps {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  payload?: Payload<NameType, ValueType>[]
  label: string
}

export const CustomTooltip: React.FC<TooltipProps> = ({ payload, label }) => {
  const { t } = useTranslation('lot-dashboard')
  const { t: commonT } = useTranslation('common')

  if (payload?.length) {
    return (
      <Container>
        <SubTitle>{`${commonT('vocabulary.daysAfterEmergenceAbbreviation')}: ${label}`}</SubTitle>
        <SubTitle>
          {t('tabs.secondTab.irrigationCard.chart.tooltipValue', {
            value: payload[0].value.toFixed(),
          })}
        </SubTitle>
        <SubTitle>
          {t('tabs.secondTab.irrigationCard.chart.tooltipDate', {
            value: dayjs(payload[0].payload.date),
          })}
        </SubTitle>
      </Container>
    )
  }

  return null
}
